import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FilterSelectionTypes } from 'src/app/services/models/filter.model';
import { TreeNode } from 'primeng/api';


@Component({
  selector: 'bhub-tree-view',
  standalone: false,
  templateUrl: './bhub-tree.component.html',
  styleUrl: './bhub-tree.component.scss'
})
export class BhubTreeComponent implements OnInit{
  @Input() nodes!: TreeNode[];
  @Input() selectionType: FilterSelectionTypes | null = null;
  @Input() selectedNodes: TreeNode[] = [];

  @Output() selectedNodesChange = new EventEmitter<TreeNode[]>();

  FilterSelectionTypes = FilterSelectionTypes;

  constructor(
  ) {
  }

  ngOnInit() {
  }

  onSelectionChange() {
    this.selectedNodesChange.emit(this.selectedNodes);
  }
}
